// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-data[data-v-211459c4]{display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%}.no-data__icon[data-v-211459c4]{font-size:180px;color:#01426b;margin-bottom:10px}.no-data__text[data-v-211459c4]{font-size:24px;text-align:center}", ""]);
// Exports
module.exports = exports;
